// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__biB2z","content":"Dashboard_content__b1RF+"};